/// <amd-module name="TFS/NetPromoterSurvey/client/RestClient/Interaction" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   aex\client\recommendation\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Interaction from "../Contracts/Interaction";

export interface IInteractionRestClient extends IVssRestClient {
    /**
     * Adds an interaction to the history for the current user
     * 
     * @param interaction - 
     */
    add(interaction: Interaction.Interaction): Promise<void>;
    /**
     * Gets the IInteractionHistory for the interaction ID.
     * 
     * @param interactionId - The ID of the interaction
     */
    get(interactionId: string): Promise<Interaction.IInteractionHistory>;
}

class InteractionRestClient extends RestClientBase implements IInteractionRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Adds an interaction to the history for the current user
     * 
     * @param interaction - 
     */
    public async add(
        interaction: Interaction.Interaction
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "3.2-preview.1",
            method: "POST",
            routeTemplate: "_apis/Interaction/Interaction",
            body: interaction
        });
    }

    /**
     * Gets the IInteractionHistory for the interaction ID.
     * 
     * @param interactionId - The ID of the interaction
     */
    public async get(
        interactionId: string
        ): Promise<Interaction.IInteractionHistory> {

        const queryValues: any = {
            interactionId: interactionId
        };

        return this.beginRequest<Interaction.IInteractionHistory>({
            apiVersion: "3.2-preview.1",
            routeTemplate: "_apis/Interaction/Interaction",
            queryParams: queryValues
        });
    }

}

export const InteractionClientName = "IInteractionRestClient";

export function getInteractionClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IInteractionRestClient {
    return pageContext.getRestClient<IInteractionRestClient>(InteractionClientName, options);
}

RestClients.add(InteractionClientName, { 
    factory: InteractionRestClient,
    options: {
        serviceInstanceType: "00000041-0000-8888-8000-000000000000"
    }
});
